// pages/Services.js
import React from "react";
import Header from "../components/home/Header";
import Services from "../components/home/Service";

function ServicesPage() {
  return (
    <div>
      <Header />
      <Services />
    </div>
  );
}

export default ServicesPage;
